<div *ngIf="modelStatistics" class="row statistics_highlights">
  <div class="col d-none d-xxl-flex"></div>
  <div class="col-sm-12 col-lg-4 col-xxl-3 mb-3">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Contactos</h5>
        <p class="card-text">
          {{modelStatistics.TotalBbdd | number}}<br>
          <span class="data">&nbsp;</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-4 col-xxl-3 mb-3">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Éxito</h5>
        <p class="card-text success">
          {{enviados | number}}<br>
          <span class="data">{{enviadosPorc | number : '1.0-2'}}%</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-lg-4 col-xxl-3 mb-3">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Visitas taller</h5>
        <p class="card-text darkgrey">
          {{modelStatistics.VisitaTaller | number}}<br>
          <span class="data">{{visitaTallerPorc | number : '1.0-2'}}%</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col d-none d-xxl-flex"></div>
</div>
<!-- <div *ngIf="modelStatistics" class="compact_data">
  <div class="row statistics_highlights">
    <div class="col statistics_data d-none"></div>
    <div class="col statistics_data">
      <span class="statistics_data_title">Facturación</span><br> {{modelStatistics.Facturacion | currency: 'EUR'}}<br>
      <span class="data"><small>Ticket medio</small><br>{{facturacionMedia | currency: 'EUR'}}</span>
    </div>
    <div class="col statistics_data d-none"></div>
  </div>
</div> -->